import type { ProductCardData } from '../types/commerce'
import { ProductCard } from './ProductCard'

export function ProductRail({ title, items }: { title: string; items: ProductCardData[] }) {
  if (!items.length) return null
  return (
    <section className="section-shell">
      <div className="section-heading"><h2>{title}</h2></div>
      <div className="product-grid product-grid--rail">{items.map(item => <ProductCard key={item.id} product={item} />)}</div>
    </section>
  )
}
